<template>
  <div class="box">
    <!--搜索区-->
    <div class="search-box">
      <el-form :inline="true" :model="queryInfo">
        <el-form-item label="Species:" required>
          <el-select
            @change="onSubmit($event)"
            v-model="queryInfo.organism"
            filterable
            remote
            :remote-method="remoteMethod"
            :loading="loading"
            width="190px"
          >
            <el-option
              v-for="item in orglist"
              :key="item.value"
      :label="item.label"
      :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Site:"  style="margin-left:-20px;">
          <el-select @change="onSubmit($event)" v-model="queryInfo.sitecategory" placeholder="All">
            <el-option label="All" value="all"></el-option>
            <el-option label="Single" value="single"></el-option>
            <el-option label="Multiple" value="multiple"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Ion(s):">
          <el-select @change="onSubmit($event)" v-model="queryInfo.iontype">
            <el-option label="All" value="all"></el-option>
            <el-option label="Single" value="single"></el-option>
            <el-option label="Multiple" value="multiple"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Specificity:" style="margin-left:25px;">
          <el-select @change="onSubmit($event)" v-model="queryInfo.specificity">
            <el-option label="No" value="no"></el-option>
            <el-option label="Yes" value="yes"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary">Download</el-button>
      </el-form>
    </div>

    <!--内容区域-->
    <div class="content-box">
      <!--显示内容-->
      <hr />
      <!--列表区-->
      <el-table
        :data="datalist"
        :row-key="getRowKey"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        border
        stripe
      >
        <el-table-column
          type="index"
          :index="(queryInfo.page-1)*(queryInfo.page_size)+1"
          :resizable="false"
          label="#"
        ></el-table-column>
        <el-table-column label="Uniprot ID" prop="accession">
          <template slot-scope="scope">
            <a
              :href="['@/../#/content/?accession='+scope.row.accession]"
              style="text-decoration:none;"
            >{{scope.row.accession}}</a>
          </template>
        </el-table-column>
        <el-table-column label="Protein" prop="protein_name"></el-table-column>
          <el-table-column label="Gene(s)" prop="genes"></el-table-column>
          <el-table-column label="Organism" prop="organism"></el-table-column>
          <el-table-column label="Common Name" prop="commonname"></el-table-column>
        <el-table-column label="Cofactor(s)" prop="cofactor">
           <template slot-scope="scope">
            <span v-for="item in val(scope.row.cofactor)" :key="item.id"><el-tag type = "info" effect="dark">{{item}} </el-tag></span>
          </template></el-table-column> 
        <el-table-column label="Site(s)" prop="site_type"></el-table-column>
        <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      </el-table>
      <hr />
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <hr />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //获取查询列表参数对象
      queryInfo: {
        sitecategory: "all",
        iontype: "all",
        organism: "homo sapiens",
        specificity: "no",
        page_size: 10,
        page: 1,
      },
      total: null,
      datalist: [],
      OptionsData: [],
      multipleSelection: [],
      url: "//127.0.0.1:8000/down?type=csv&params=",
      flag: false,
       loading: false,
       list:[],
       orglist:[],
       item:'',
    };
  },
  //获取查询列表
  created() {
    this.getOptionsData();
    this.onSubmit();
  },

  //方法
  methods: {
    async onSubmit() {
      const res = await this.$http.get("categorys", { params: this.queryInfo });
      if (res.status !== 200) {
        return this.$message.error("获取数据列表失败");
      }
      this.datalist = res.data.results;
      this.total = res.data.count;
    },
    //获取查询集
    async getOptionsData() {
      const res = await this.$http.get("species", { params: { limit: 7239 } });
      if (res.status !== 200) {
        return this.$message.error("获取数据列表失败");
      }
      this.OptionsData = res.data.results;
      this.list = this.OptionsData.map(item =>{
        return {value:item.organism,label:item.organism+' ('+item.commonname+' )'}
      })
    },
    //搜索查询集
     remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.orglist = this.list.filter(item => {
              return item.label.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);} else {
          this.orglist = [];
        }
    },
    //分页索引
    show() {
      if (this.queryInfo.organism) {
        this.flag = !this.flag;
      } else {
        alert("Please select a species!");
        this.flag = false;
      }
    },
    //处理后端字符串
     val(str){
    var res = eval(str);
     return res;
   },


    //监听每页显示变化
    handleSizeChange(newPage_size) {
      this.queryInfo.page_size = newPage_size;
      this.onSubmit();
    },
    //监听当前页变化
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage;
      this.onSubmit();
    },
    getRowKey(row) {
      return row.id;
    },
    handleSelectionChange(val) {
      var newList = [];
      val.forEach((obj) => {
        newList.push(obj.accession);
      });
      this.multipleSelection = newList;
    },
  },
};
</script>

<style lang="less" scoped>
.search-box {
  padding-top: 70px;
    width: 100%;
    text-align: center;
  }
.el-form-item{
  width:285px;
  margin:0;
 /deep/ .el-form-item__label{
    width: 100px;
  }
  /deep/.el-form-item__content{
    width:180px
  }
}


.content-box{
  margin-top: 5px;
}
  

.el-pagination {
  display: flex;
  justify-content: center;
}
.el-form {
  /deep/ .el-form-item__label {
    color: rgb(8, 0, 0);
    font-size: 1.2em;
  }
}
.el-table {
  /deep/ th {
    background-color: #adc3ce;
    color: rgb(8, 0, 0);
    font-size: 1.3em;
    text-align: center;
  }
  /deep/ td {
    text-align: center;
  }
}

</style>